import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: Poppins;
  margin-top: 32px;
`;

export const Title = styled.h5`
  width: 100%;
  width: 100%;
  font-weight: bold;
  text-align: left;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.travelDetails.sectionsTitle};
`;

export const HotelImage = styled.img`
  height: 128px;
  border-radius: 16px;
  margin-bottom: 16px;
  object-fit: cover;
`;

export const HotelName = styled.span`
  height: 24px;
  font-size: 22px;
  font-weight: 600;
  flex: 1;
  line-height: 1.09;
  letter-spacing: -0.66px;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.travelDetails.sectionsTitle};
`;

export const HotelAddress = styled.p`
  height: 48px;
  font-size: 16px;
  line-height: 1.5;
  margin-top: 16px;
  color: ${({ theme }) => theme.travelDetails.sectionsTitle};
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;
